<template>
  <div class="form-wrap">
    <form @submit.prevent>
      <div class="form-inputs">
        <input v-model="email" autocomplete="current-email" placeholder="Email" type="text">
        <input
          v-model="password"
          autocomplete="current-password"
          placeholder="Password"
          type="password"
        >
        <button @click="onSubmit" type="button">Login</button>
      </div>
    </form>

    <transition name="msg">
      <div class="msg" v-show="_message">{{_message}}&nbsp;</div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    error: {
      required: false
    }
  },
  data() {
    return {
      email: "",
      password: "",
      message: ""
    };
  },
  computed: {
    _message() {
      if (this.error) {
        return this.errorText(this.error);
      }
    }
  },
  methods: {
    errorText(error) {
      console.log(error);
      if (error.code === "auth/invalid-email") {
        return "Enter a valid email address";
      }
      if (error.code === "auth/wrong-password") {
        return "Wrong password.";
      }
      if (error.code === "auth/argument-error") {
        return "The email is wonky yo.";
      }
      return error;
    },
    onSubmit(ev) {
      this.$emit("onsubmit", { email: this.email, password: this.password });
    },
    isEmail(email) {
      return true;
    }
  }
};
</script>

<style lang="scss" scoped>
$color-error: #e7f526;
div.msg {
  color: $color-error;
  font-size: 2rem;
  text-align: left;
  margin: 0;
  padding: 0;
  font-family: "Roboto";
  font-weight: 300;
  position: relative;
  margin-top: 20px;
}

.msg-enter-active,
.msg-leave-active {
  transition: all 0.5s;
}

.msg-enter,
.msg-leave-to {
  opacity: 0;
  transform: translateY(-39px);
  overflow: hidden;
}
</style>